//Validate text field for no value
export function requiredField(value) { return value === '' || value === null }
